import AMP from './sdk/amp';
export default AMP;
